module.exports = __webpack_public_path__ + "assets/img/btn-detail-975698b4.png";